import PropTypes from 'prop-types';
import NodeRenderer from '../NodeRenderer';
import NodeContent from '../NodeContent';
import NodeSpacer from '../NodeSpacer';

function ApprovalNode(props) {
  const { keyPath, branches } = props;

  return (
    <div className="icp-workflow-node approval-node">
      <NodeContent {...props} />
      <NodeSpacer />
      <div className="approval-node-branches">
        {(branches || []).map((branch, index) => {
          const { subFlow } = branch;
          const currentKeyPath = keyPath.concat('branches', index);
          const nextKeyPath = currentKeyPath.concat('subFlow');
          return (
            <div key={index} className="approval-node-branch">
              <NodeRenderer keyPath={nextKeyPath} nodeList={subFlow} />
            </div>
          );
        })}
      </div>
    </div>
  );
}

ApprovalNode.propTypes = {
  keyPath: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  branches: PropTypes.arrayOf(PropTypes.shape({})),
};

export default ApprovalNode;
